export default __webpack_public_path__ + "static/media/cara.adece7a6.webp";